export default function setChatbotConfig(state, action) {
  Object.assign(state, action.payload);
}
